import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class InternalResaleRateSettingsModel extends BaseAPIModel {
    fields() {
        return {
            min_price: null,
            max_price: null,
            resale_rate: null,
            resaler_fee: []
        };
    }

    static save(data, method, { organizationId, eventId, rateId }) {
        const url = this.listUrl({ organizationId, eventId, rateId });
        return fetcher[method](url, { data: data });
    }

    static listUrl({ organizationId, eventId, rateId }) {
        if (!organizationId || !eventId || !rateId) {
            throw new Error('[InternalResaleRateSettingsModel] organizationId, eventId and rateId are required');
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/rates/${rateId}/resale`;
    }

    static list(item) {
        return item;
    }

    static cancelResaleTickets(args) {
        return fetcher.post(`${this.listUrl(args)}/cancel_tickets`);
    }
}
